import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import {requestPassword, validateEmail} from "../_redux/authCrud";



function EmailVerification(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(()=>{
    validateEmail(props.match.params.token)
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        setSuccess(false);
        //"Well done, you can use Arabfit now, Thank you!"
      }).then(r=>{
        setLoading(false);
      });
  }, [props.match.params.token])


  return (
    <>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">Email Validation</h3>
          <div className="alert-text font-weight-bold">
            {
              loading ?
                "Verifying..." :
                success ?
                  "Well done, you can use Arabfit now, Thank you!" :
                  "Something went wrong!"

            }
          </div>
          <Link to="/auth/login">
            <div className={'mt-5'}>
              Login
            </div>
          </Link>
        </div>

      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(EmailVerification));
